;
define("shopping_layout.tpl", function(){});

